module.exports = __webpack_public_path__ + "img/greetings_mobile.5fd70842.png";